import axios from "../../axiosConfig/axios";

export const UserRegisterApi = {
    createNewUser(data) {
        return axios.post(`user`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
    }
};
